import { Component, Input, Output, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { GlobalService } from '../../../_service/GlobalService';
import { PricingService } from '../../../_service/PricingService';
import { BaseorderlineComponent } from '../baseorderline.component';
import { LocalizedDatePipe } from '../../pipe/localizedDate.pipe';
import { PricetagComponent } from '../../pricetag/pricetag.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ToggleComponent } from '../../toggle/toggle.component';
import { ImageComponent } from '../../image/image.component';
import { NgClass } from '@angular/common';
import { QuantityselectionComponent } from '../../quantityselection/quantityselection.component';
import { PersonselectionComponent } from '../../personselection/personselection.component';
import { QuantityselectionCompactComponent } from '../../quantityselection/quantityselection-compact.component';
import { PersonselectionCompactComponent } from '../../personselection/personselection-compact.component';

@Component({
    selector: 'boxline',
    templateUrl: './boxline.component.html',
    styleUrls: ['./boxline.component.scss'],
    imports: [NgClass, ImageComponent, ToggleComponent, ReactiveFormsModule, PricetagComponent, TranslateModule, LocalizedDatePipe, QuantityselectionComponent, PersonselectionComponent, QuantityselectionCompactComponent, PersonselectionCompactComponent]
})
export class BoxlineComponent extends BaseorderlineComponent implements OnInit, OnDestroy {

  //line becomes orderline (orderline in basecomponent migrates to any)
  //repeatable will be removed, it will be set and updated in the orderlines
  //repeatableChange will become repeatalbeproductschange which returns the list of subscriptionrepeatableproducts
  //box or product have to be set as a input variable

  @Input() showPrice: boolean = true;
  @Input() condensed = false;
  @Input() useSummaryPageStyle: boolean = false;
  @Input() hidePriceSmallTag: boolean = false;
  @Input() removable: boolean = false;
  @Input() recipefirstLayout: boolean = false;
  @Output() removeline = new EventEmitter<any>();
  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public _translate: TranslateService,
    public _pricingService: PricingService,
    public _globalService: GlobalService,
  ) {
    super(route, router, _translate, _pricingService, _globalService);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  removeBoxline(): void {
    if (!this.removable) {
      this.removable = this.removeline.observers.length > 0;
    }
    if (this.removable) {
      this.removeline.emit(this._box);
    }
  }

}
